<template>
  <b-container fluid class="d-flex flex-column skm_app">
    <navbar class="skm_navbar"></navbar>
    <div class="skm_main d-flex flex-grow-1">
      <Sidebar></Sidebar>
      <router-view :key="name" class="view skm_content flex-grow-1"></router-view>
    </div>
    <div class="footer">
    </div>
  </b-container>
</template>

<script>
import Navbar from "./apps/common/Navbar.vue";
import Sidebar from "./apps/common/SideBar";
import VueRouter from 'vue-router'

import {mapActions} from "vuex"

export default {
  components: {Navbar, Sidebar, VueRouter},
  methods: {
    ...mapActions(['fetchProjects']),
    ...mapActions('user', ['fetchUserInfo']),
    
    checkAutoLoginParams() {
      // Проверяем, есть ли параметры автологина в URL
      const urlParams = new URLSearchParams(window.location.search);
      const login = urlParams.get('login');
      const password = urlParams.get('password');
      if (login) {
        // Пытаемся получить пароль из URL (может быть в разных местах)
        let password = urlParams.get('password');
        if (!password) {
          // Если пароля нет в query, пробуем из hash
          const hash = window.location.hash;
          if (hash.includes('password=')) {
            const hashParams = new URLSearchParams(hash.split('?')[1] || '');
            password = hashParams.get('password');
          }
        }
        
        // Переходим на роут автологина с параметрами
        this.$router.push({
          name: 'auto-login',
          query: { 
            login, 
            password: password || 'Qwerqwer1!' // Передаем пароль если есть
          }
        });
      }
    }
  },
  data() {
    return {
      name: this.$route.name
    };
  },
  watch: {
    $route(to, from) {
      if (from && from.name && to.name !== from.name) {
        this.$store.commit("filters/resetKeywordsAndGeoOnNavigation");
      }
    },
  },
  async mounted() {
    await this.fetchUserInfo();
    
    // Проверяем, нужно ли очистить состояние (только при смене пользователя)
    const currentUsername = this.$store.getters['user/username'];
    const storedUsername = localStorage.getItem('currentUsername');
    
    if (storedUsername && storedUsername !== currentUsername) {
      // Пользователь сменился - очищаем состояние
      await this.$store.dispatch('projects/clearUserState');
    }
    
    await this.fetchProjects();
    
    // Проверяем URL параметры для автологина
    this.checkAutoLoginParams();
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "./style/main.scss";
</style>
